import PropTypes from 'prop-types';
import { values } from 'ramda';

export const MEDIA_THEMATIC = {
  ECOLOGY: 'ecology',
  DIGITAL: 'digital',
  PEOPLE: 'people',
  BANK: 'bank',
  LOGISTICS: 'logistics',
  DT: 'dt',
  HUMAN_RESOURCES: 'human-resource',
  PHILATELY: 'philately',
  TELEPHONY: 'telephony',
  REAL_ESTATE: 'real-estate',
  INTERNATIONAL: 'international',
  EVENT: 'event',
  FINANCIAL: 'financial',
};

export const MediaThematicType = PropTypes.oneOf(values(MEDIA_THEMATIC));
